import { Component, OnInit } from '@angular/core';
import { ArticleService } from '../services/article.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.less']
})
export class DocumentsComponent implements OnInit {
  getFullYear: number = new Date().getFullYear();
  queryKeyword: string;
  queryNumber: string;
  queryDocumentType: string;
  queryDepartment: string;
  queryField: string;
  queryYear: string;
  queryFolder:string;
  article:any=[];
  loading = false;
  perPage = 10;
  page = 1;
  total:string;
  isVisible:any;
  searchKeywordValue:any;
  pageIndex:number;
  isCollapsed = false;
  documentTypeData:any=[];
  documentFolderData:any=[];
  documentFieldData:any=[];
  documentDepartmentData:any=[];
  dataFilter:any=[];
  isRefresh:boolean = false;
  webViewLink:string = "https://drive.google.com/file/d/";
  constructor(
    private articleService: ArticleService,
    private router: Router
  ) { }

  ngOnInit() {
    this.pageIndex = 1;
    this.getDocumentType();
    this.getDocumentFolder();
    this.getDocumentField();
    this.getDocument();
    this.getDocumentDepartment();
  }

  getDocument() {
    this.loading = true; 
    this.articleService.getDocument(this.perPage, this.page).subscribe((res:any)=>{
      this.loading = false;
      this.total = res.data.total;
      this.article = res.data.docs;
      console.log('this.article', this.article);
      
    }); 
  }

  searchKeyword(queryKeyword:string, queryNumber:string, queryYear:string) {
    const keyword = queryKeyword;
    const number = queryNumber;
    const year = queryYear;
    const queryValue = [
      (keyword)? 'title='+keyword : '',
      (number)?'number='+number: '',
      (year)?'year='+year: '',
      (this.queryField)?'field='+this.queryField: '',
      (this.queryDepartment)?'department='+this.queryDepartment: '',
      (this.queryFolder)?'folder='+this.queryFolder: '', 
      (this.queryDocumentType)?'document_type='+this.queryDocumentType: '', 
    ];
    
    const filteredArr = queryValue.filter((e) => { return e != ""; }).join('&');
    this.searchKeywordValue = filteredArr;
    this.pageIndex = 1;
    this.onPageIndexChange(1);
  }

  keyDownFunction(event: any){
    if (event && event.keyCode === 13) {
      const keyword = this.queryKeyword;
      this.searchKeyword(this.queryKeyword, this.queryNumber, this.queryYear);
    }
  }

  dateChange(result: Date): void {
  }

  showModal(id:string): void {
    this.isVisible = id;
  }

  handleOk(): void {
    this.isVisible = false;
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  onPageIndexChange($event) {
    // console.log('this.searchKeywordValue', this.searchKeywordValue)
    if(this.searchKeywordValue != undefined){
      this.articleService.searchDocument(this.perPage, $event, this.searchKeywordValue ).subscribe((res:any)=>{
        this.loading = false;
        this.total = res.data.total;
        this.article = res.data.docs;
      }); 
    }else{
      this.articleService.getDocument(this.perPage, $event).subscribe((res:any)=>{
        this.loading = false;
        this.total = res.data.total;
        this.article = res.data.docs;
      }); 
    }

  }

  refresh(): void {
    this.getDocument();
    this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
      this.router.navigate(['documents']);
    }); 
  }

  getDocumentType(): void{
    this.articleService.getDocumentType().subscribe((res:any)=>{
      this.documentTypeData = res.data.docs;      
    }); 
  }

  getDocumentFolder(): void{
    this.articleService.getDocumentFolder().subscribe((res:any)=>{
      var data = res.data.docs;
      var newArray = data.map((item: any) => {
        return {
          title: item.title,
          key: item._id,
          children: item.children.map((item: any) => {
            return {
              title: item.title,
              key: item._id,
              isLeaf: true
            };
          }),
        };
      });
      this.documentFolderData = newArray;
      // console.log('newArray', newArray);
      
    }); 
  }

  getDocumentField(): void{
    this.articleService.getDocumentField().subscribe((res:any)=>{
      this.documentFieldData = res.data.docs;      
    }); 
  }

  getDocumentDepartment():void {
    this.articleService.getDocumentDepartment().subscribe((res:any)=>{
      this.documentDepartmentData = res.data.docs;
    }); 
  }

  documentTypeClick(data:any){
    this.queryDocumentType = data;
    this.searchKeyword(this.queryKeyword, this.queryNumber, this.queryYear);
  }

  documentFolderClick(data:any){
    this.queryFolder = data;
    this.searchKeyword(this.queryKeyword, this.queryNumber, this.queryYear);
  }

  documentFieldClick(data:any){
    this.queryField = data;
    this.searchKeyword(this.queryKeyword, this.queryNumber, this.queryYear);
  }

  documentDepartmentClick(data:any){
    this.queryDepartment = data;    
    this.searchKeyword(this.queryKeyword, this.queryNumber, this.queryYear);
  }

}
